import React, { useMemo, useState } from 'react';

type FaqSidebarProps = {
  t: (key: any) => string;
  accentColor: string;
  onCollapsedChange?: (isCollapsed: boolean) => void;
};

export const FaqSidebar: React.FC<FaqSidebarProps> = ({ t, accentColor, onCollapsedChange }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [isFaqCollapsed, setIsFaqCollapsed] = useState(true); // minimized by default (like previous landing)

  const faqItems = useMemo(
    () => [
      { q: 'faqQ1', a: 'faqA1' },
      { q: 'faqQ2', a: 'faqA2' },
      { q: 'faqQ3', a: 'faqA3' },
      { q: 'faqQ4', a: 'faqA4' },
      { q: 'faqQ5', a: 'faqA5' },
      { q: 'faqQ6', a: 'faqA6' },
    ],
    []
  );

  return (
    <aside
      className={`faqSidebar ${isFaqCollapsed ? 'faqSidebarCollapsed' : ''}`}
      aria-label="Swarmind frequently asked questions"
      style={{ ['--faq-accent' as any]: accentColor } as React.CSSProperties}
    >
      <button
        type="button"
        className="faqToggleButton"
        onClick={() =>
          setIsFaqCollapsed(prev => {
            const next = !prev;
            onCollapsedChange?.(next);
            return next;
          })
        }
        aria-label={isFaqCollapsed ? 'Expand FAQ sidebar' : 'Collapse FAQ sidebar'}
      >
        <span
          className="faqToggleIcon"
          aria-hidden="true"
          style={{
            maskImage: `url(${process.env.PUBLIC_URL || ''}/icons/double_arrows.svg)`,
            WebkitMaskImage: `url(${process.env.PUBLIC_URL || ''}/icons/double_arrows.svg)`,
          }}
        />
      </button>

      <div className="faqContent" aria-hidden={isFaqCollapsed}>
        <h2 className="faqTitle">{t('faqTitle')}</h2>
        <div className="faqList">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className={`faqItem ${isOpen ? 'faqItemOpen' : ''}`}>
                <button
                  type="button"
                  className="faqQuestionButton"
                  onClick={() => setOpenIndex(prev => (prev === index ? null : index))}
                  aria-expanded={isOpen}
                  tabIndex={isFaqCollapsed ? -1 : 0}
                >
                  <span className={`faqQuestion ${isOpen ? 'faqQuestionOpen' : ''}`}>
                    {t(item.q)}
                  </span>
                  <span className="faqChevron" aria-hidden="true">
                    {isOpen ? '−' : '+'}
                  </span>
                </button>
                {isOpen && (
                  <div className="faqAnswerWrapper">
                    <p className="faqAnswer">{t(item.a)}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </aside>
  );
};

